import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

import { Store } from 'stores'
import { screensLabelEN, screensLabelRU } from './screens/screensData'

interface IInjectedProps {
  store: Store
}

@inject('store')
@observer
class Social extends Component {
  render() {
    const { currentScreenId, windowWidth, isFocus, language } = (this
      .props as IInjectedProps).store
    return (
      <div className="social">
        <ul className="social-ul m-auto">
          {/* <div className="social-item"> */}
            {/* <li>
              <a
                rel="noreferrer"
                className="fb"
                href="https://www.facebook.com"
                target="_blank"
              >
                <svg
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.75 10.5V7.875C13.75 7.1505 14.31 7.21875 15 7.21875H16.25V3.9375H13.75C11.6783 3.9375 10 5.69975 10 7.875V10.5H7.5V13.7812H10V21H13.75V13.7812H15.625L16.875 10.5H13.75Z"
                    fill="currentColor"
                  />
                  <rect
                    x="0.5"
                    y="0.5"
                    width="19"
                    height="20"
                    rx="2.5"
                    stroke="currentColor"
                  />
                </svg>
              </a>
            </li> */}
          {/* </div>
          <div className="social-item"> */}
            {/* <li>
              <a
                rel="noreferrer"
                className="insta"
                href="https://www.instagram.com"
                target="_blank"
              >
                <svg
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.75 0H6.25C2.79875 0 0 2.93869 0 6.5625V14.4375C0 18.0613 2.79875 21 6.25 21H13.75C17.2013 21 20 18.0613 20 14.4375V6.5625C20 2.93869 17.2013 0 13.75 0ZM18.125 14.4375C18.125 16.9706 16.1625 19.0312 13.75 19.0312H6.25C3.8375 19.0312 1.875 16.9706 1.875 14.4375V6.5625C1.875 4.02938 3.8375 1.96875 6.25 1.96875H13.75C16.1625 1.96875 18.125 4.02938 18.125 6.5625V14.4375Z"
                    fill="currentColor"
                  />
                  <path
                    d="M10 5.25C7.23875 5.25 5 7.60069 5 10.5C5 13.3993 7.23875 15.75 10 15.75C12.7613 15.75 15 13.3993 15 10.5C15 7.60069 12.7613 5.25 10 5.25ZM10 13.7812C8.2775 13.7812 6.875 12.3086 6.875 10.5C6.875 8.69006 8.2775 7.21875 10 7.21875C11.7225 7.21875 13.125 8.69006 13.125 10.5C13.125 12.3086 11.7225 13.7812 10 13.7812Z"
                    fill="currentColor"
                  />
                  <path
                    d="M15.375 5.55537C15.7429 5.55537 16.0412 5.24217 16.0412 4.85581C16.0412 4.46945 15.7429 4.15625 15.375 4.15625C15.007 4.15625 14.7087 4.46945 14.7087 4.85581C14.7087 5.24217 15.007 5.55537 15.375 5.55537Z"
                    fill="currentColor"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear"
                      x1="1.83081"
                      y1="19.0778"
                      x2="18.9657"
                      y2="2.75857"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="currentColor" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear"
                      x1="6.46456"
                      y1="14.2122"
                      x2="13.8802"
                      y2="7.14974"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="currentColor" />
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear"
                      x1="14.9039"
                      y1="5.35056"
                      x2="15.892"
                      y2="4.40942"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="currentColor" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
            </li> */}
          {/* </div> */}
          <div className="social-item">
            <li>
              <a
                rel="noreferrer"
                className="tg"
                href="https://tlgg.ru"
                target="_blank"
              >
                {/* <svg
            width="20"
            height="18"
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.84765 11.5337L7.51682 16.4197C7.99015 16.4197 8.19515 16.2062 8.44098 15.9499L10.6601 13.723L15.2585 17.2589C16.1018 17.7524 16.696 17.4925 16.9235 16.4442L19.9418 1.59373L19.9426 1.59285C20.2101 0.283855 19.4918 -0.22802 18.6701 0.0931048L0.928482 7.22523C-0.282352 7.71873 -0.264018 8.42748 0.722648 8.74861L5.25848 10.23L15.7943 3.30786C16.2901 2.96311 16.741 3.15386 16.3701 3.49861L7.84765 11.5337Z"
              fill="currentColor"
            />
          </svg> */}
                <svg
                  width="20"
                  height="18"
                  viewBox="0 0 20 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.8594 3.04851C15.8596 3.04851 15.8575 3.05104 15.8522 3.05611C15.8565 3.05104 15.8591 3.0485 15.8594 3.04851ZM15.3671 2.78588L5.14579 9.69317L0.961476 8.28756L0.960733 8.28731C0.946337 8.28249 0.932651 8.27769 0.91965 8.27292C0.994064 8.22738 1.09149 8.17662 1.21676 8.12401C1.21732 8.12378 1.21788 8.12354 1.21844 8.12331L18.9527 0.790498C19.0599 0.747889 19.1267 0.747858 19.1536 0.751469C19.1722 0.753963 19.1739 0.757295 19.1743 0.758141C19.1743 0.758222 19.1744 0.75828 19.1744 0.758312C19.1794 0.763534 19.308 0.919836 19.2186 1.43034L19.206 1.49387L16.1887 16.7635C16.1148 17.111 16.022 17.2223 15.995 17.2492C15.9613 17.2494 15.8669 17.2367 15.6833 17.1316L11.1254 13.5267L10.5934 13.106L10.1215 13.5931L8.36612 15.4049L8.57706 12.2006L16.8885 4.14061C16.8892 4.13992 16.8899 4.13922 16.8907 4.13853C17.0366 3.99848 17.2439 3.74585 17.2559 3.39395C17.2714 2.94034 16.9663 2.64526 16.675 2.53393C16.4208 2.43678 16.1629 2.45728 15.9677 2.50495C15.7614 2.55532 15.557 2.6516 15.3671 2.78588ZM16.0097 17.2477C16.0098 17.2478 16.0083 17.2483 16.0052 17.2486C16.0081 17.2477 16.0097 17.2476 16.0097 17.2477ZM0.725528 8.42941C0.725484 8.4294 0.72591 8.42867 0.726938 8.42721C0.726086 8.42868 0.725572 8.42941 0.725528 8.42941Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                </svg>
              </a>
            </li>
          </div>
          <div className="social-item">
            <li>
              <a
                rel="noreferrer"
                className="vk"
                href="https://vk.com"
                target="_blank"
              >
                {/* <svg
            width="20"
            height="12"
            viewBox="0 0 20 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.786 11.9316H10.9811C10.9811 11.9316 11.3424 11.8896 11.5261 11.6809C11.6961 11.4893 11.6899 11.1296 11.6899 11.1296C11.6899 11.1296 11.6661 9.44556 12.4112 9.19748C13.145 8.95334 14.0876 10.8251 15.0864 11.5457C15.8415 12.0904 16.4152 11.971 16.4152 11.971L19.0867 11.9316C19.0867 11.9316 20.4843 11.8411 19.8217 10.6873C19.768 10.5928 19.4355 9.83409 17.8353 8.27473C16.1602 6.64185 16.3852 6.907 18.4029 4.0836C19.6317 2.3641 20.123 1.31402 19.9693 0.865113C19.823 0.437206 18.9192 0.55009 18.9192 0.55009L15.914 0.568466C15.914 0.568466 15.6914 0.536964 15.5252 0.640659C15.3639 0.743041 15.2602 0.979309 15.2602 0.979309C15.2602 0.979309 14.7839 2.31028 14.1488 3.44174C12.81 5.82936 12.2737 5.95537 12.0549 5.80704C11.5461 5.46183 11.6736 4.41831 11.6736 3.67801C11.6736 1.3639 12.0074 0.399141 11.0223 0.149747C10.6948 0.0670536 10.4548 0.0119246 9.61849 0.00273639C8.54591 -0.00907699 7.63709 0.00667418 7.12331 0.270506C6.78078 0.446394 6.51701 0.838861 6.67827 0.861176C6.87704 0.88874 7.32707 0.988497 7.56584 1.32977C7.87461 1.76949 7.86336 2.75919 7.86336 2.75919C7.86336 2.75919 8.04087 5.48283 7.44958 5.82148C7.0433 6.05381 6.48701 5.57996 5.29317 3.41286C4.68187 2.30372 4.21934 1.07644 4.21934 1.07644C4.21934 1.07644 4.13058 0.848049 3.97182 0.725978C3.77931 0.577654 3.50929 0.530401 3.50929 0.530401L0.651577 0.548777C0.651577 0.548777 0.222796 0.561903 0.0652839 0.75748C-0.0747265 0.932056 0.0540331 1.29171 0.0540331 1.29171C0.0540331 1.29171 2.2917 6.78755 4.82439 9.55845C7.14831 12.0983 9.786 11.9316 9.786 11.9316Z"
              fill="currentColor"
            />
          </svg> */}
                <svg
                  width="20"
                  height="13"
                  viewBox="0 0 20 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.1208 12.5C13.0142 12.5 11.9825 10.6683 12.2058 10.1417C12.2025 9.74833 12.1992 9.37 12.2125 9.14C12.3958 9.19167 12.8283 9.41083 13.7217 10.2792C15.1008 11.6708 15.4533 12.5 16.5675 12.5H18.6183C19.2683 12.5 19.6067 12.2308 19.7758 12.005C19.9392 11.7867 20.0992 11.4033 19.9242 10.8067C19.4667 9.37 16.7983 6.88917 16.6325 6.6275C16.6575 6.57917 16.6975 6.515 16.7183 6.48167H16.7167C17.2433 5.78583 19.2533 2.77417 19.5492 1.56917C19.55 1.5675 19.5508 1.565 19.5508 1.5625C19.7108 1.0125 19.5642 0.655833 19.4125 0.454167C19.1842 0.1525 18.8208 0 18.33 0H16.2792C15.5925 0 15.0717 0.345833 14.8083 0.976666C14.3675 2.0975 13.1292 4.4025 12.2008 5.21833C12.1725 4.0625 12.1917 3.18 12.2067 2.52417C12.2367 1.245 12.3333 0 11.0058 0H7.7825C6.95083 0 6.155 0.908333 7.01667 1.98667C7.77 2.93167 7.2875 3.45833 7.45 6.08C6.81667 5.40083 5.69 3.56667 4.89333 1.2225C4.67 0.588333 4.33167 0.000833273 3.37917 0.000833273H1.32833C0.496667 0.000833273 0 0.454166 0 1.21333C0 2.91833 3.77417 12.5 10.1208 12.5ZM3.37917 1.25083C3.56 1.25083 3.57833 1.25083 3.7125 1.63167C4.52833 4.03417 6.35833 7.58917 7.695 7.58917C8.69917 7.58917 8.69917 6.56 8.69917 6.1725L8.69833 3.0875C8.64333 2.06667 8.27167 1.55833 8.0275 1.25L10.9508 1.25333C10.9525 1.2675 10.9342 4.66583 10.9592 5.48917C10.9592 6.65833 11.8875 7.32833 13.3367 5.86167C14.8658 4.13583 15.9233 1.55583 15.9658 1.45083C16.0283 1.30083 16.0825 1.25 16.2792 1.25H18.33H18.3383C18.3375 1.2525 18.3375 1.255 18.3367 1.2575C18.1492 2.1325 16.2983 4.92083 15.6792 5.78667C15.6692 5.8 15.66 5.81417 15.6508 5.82833C15.3783 6.27333 15.1567 6.765 15.6883 7.45667H15.6892C15.7375 7.515 15.8633 7.65167 16.0467 7.84167C16.6167 8.43 18.5717 10.4417 18.745 11.2417C18.63 11.26 18.505 11.2467 16.5675 11.2508C16.155 11.2508 15.8325 10.6342 14.6017 9.3925C13.495 8.31583 12.7767 7.87583 12.1225 7.87583C10.8525 7.87583 10.945 8.90666 10.9567 10.1533C10.9608 11.505 10.9525 11.0775 10.9617 11.1625C10.8875 11.1917 10.675 11.25 10.1208 11.25C4.83333 11.25 1.39 2.8575 1.2575 1.25333C1.30333 1.24917 1.93417 1.25167 3.37917 1.25083Z"
                    fill="currentColor"
                  />
                </svg>
              </a>
            </li>
          </div>
        </ul>
      </div>
    )
  }
}
export default Social
